import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { ConfigurationKey } from '@/app-modules/config';
import { ISweetAlertService } from '@/app-modules/sweet-alert-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { User } from '@/app-modules/store/modules/user';

@Component({
  name: 'AlertWordsComponent'
})

export default class AlertWordsComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private alertWords: string = '';

  private async mounted() {
    this.alertWords = this.userPreferences.alertWords.join(',');
  }

  private get sweetAlertService(): ISweetAlertService {
    return this.$container.get(SERVICE_IDENTIFIERS.ISweetAlertService);
  }

  public saveSettings() {
    this.userPreferences.alertWords = this.alertWords.toLocaleLowerCase().split(',');
    this.resetCleansedAlertWordsForUser();
  }

  private async resetAlertWords() {
    const result = await this.sweetAlertService.show({
      title: this.$lang.app.userSettings.alertWords.resetTitle,
      text: this.$lang.app.userSettings.alertWords.resetMessage,
      type: 'warning',
      allowOutsideClick: false,
      focusConfirm: false,
      showConfirmButton: true,
      showCancelButton: true
    });

    if (result && result.value) {
      this.alertWords = this.configService.getConfigurationItem(ConfigurationKey.DEFAULT_ALERT_WORDS);
    }
  }

  private resetCleansedAlertWordsForUser() {
    const user = this.$tombolaStore.Get(User);
    user.cleansedAlertWords = null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/alert-words/alert-words.component.ts